import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from '../../components/Layout/Layout'

const NewAboutPage = () => {

    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: "ease-out",
            once: false,
        });
    }, []);
    return (
        <>
            <Layout>
                <section
                    className="section section-masthead text-center"
                    data-arts-os-animation="animated"
                    style={{
                        backgroundImage: 'url("/img/abouthome.png")',
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                    }}
                >
                    <div className="container-fluid">
                        <header className="row justify-content-center">
                            <div className="col">
                                <div>
                                    <div className="px-4">
                                        <h1 className="text-white text_42_about" data-aos="zoom-out-up">
                                            About Us
                                        </h1>
                                        <div>
                                            <span>
                                                <div className="text-white text_48_about" data-aos="zoom-out-up">
                                                    At Immsy, We Put Humans First
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                    </div>
                </section>

                <section className="section section-masthead bg-white">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className='col-md-6'>
                                <h2 data-aos="zoom-out-up" className="text_40_about">
                                    Our Mission
                                </h2>
                                <div>
                                    <div className="text_20_about" data-aos="zoom-out-up">
                                        "To transform personalized wellness and health by integrating cutting-edge technologies such as artificial intelligence, genetic, and biometric analysis.""We provide tailored health solutions that are accessible to all, with the goal of redefining how individuals interact with their own health. By equipping our users with powerful and intuitive tools, we enable them to anticipate, monitor, and enhance their daily well-being, leading to a healthier, more balanced, and fulfilling life."
                                    </div>
                                </div>
                            </div>
                            <div data-aos="zoom-out-up" className="col-md-6 d-flex justify-content-end align-items-end ">
                                <img src="/img/about.jpeg" alt="Innovative Wellness Technologies" class="mission-image w-100" />
                            </div>
                        </div>
                    </div>
                    <div />
                </section>

                <section className="section d-flex flex-column justify-content-center align-items-center">
                    <h2 className='text_42_about text-center mb-5'>
                        What Makes Us Different
                    </h2>
                    <div className="px-4">
                        <div className="row">
                            <article data-aos="zoom-out-up" className='col-md-4'>
                                <p className="text_32_about">Our Mission</p>
                                <div className="text_18_about">
                                    <span>
                                        "To transform personalized wellness and health by integrating cutting-edge technologies such as artificial intelligence, genetic, and biometric analysis.""We provide tailored health solutions that are accessible to all, with the goal of redefining how individuals interact with their own health. By equipping our users with powerful and intuitive tools, we enable them to anticipate, monitor, and enhance their daily well-being, leading to a healthier, more balanced, and fulfilling life."
                                    </span>
                                </div>
                            </article>
                            <article data-aos="zoom-out-up" className='col-md-4'>
                                <p className="text_32_about">Our Vision</p>
                                <div className="text_18_about">
                                    <span>
                                        "To create a well-being ecosystem that integrates the physical, mental, and emotional.""We envision a world where everyone has access to the tools and resources needed to live a balanced and fulfilling life. Our goal is to harmonize body, mind, and emotions by offering a holistic approach to well-being that supports every aspect of life."
                                    </span>
                                </div>
                            </article>
                            <article data-aos="zoom-out-up" className='col-md-4'>
                                <p className="text_32_about">Our Ambition</p>
                                <div className="text_18_about">
                                    <span>
                                        "To make well-being accessible to all.""Our ambition is to democratize access to high-quality well-being programs by breaking down economic and geographical barriers. We strive to ensure that everyone, regardless of their location or circumstances, can benefit from our services and lead a healthier, more balanced life."
                                    </span>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>
            </Layout>
        </>
    )
}

export default NewAboutPage

